<div [ngClass]="{ error: errored, success: progress === 100 && !errored }" class="progress-cont">
  <ng-container *rxLet="this | method: 'getOverrideBarColor' as overrideBarColor">
    <div
      [ngClass]="{ default: !overrideBarColor }"
      [style.background-color]="overrideBarColor"
      [style.width]="progress + '%'"
      class="progress"></div>
  </ng-container>
</div>
